import { render, staticRenderFns } from "./Statistics.vue?vue&type=template&id=15ecf2f9"
import script from "./Statistics.vue?vue&type=script&lang=js"
export * from "./Statistics.vue?vue&type=script&lang=js"
import style0 from "./Statistics.vue?vue&type=style&index=0&id=15ecf2f9&prod&lang=scss"
import style1 from "./Statistics.vue?vue&type=style&index=1&id=15ecf2f9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports